module.exports = __webpack_public_path__ + "img/icon_gq_act1.b4209ba7.png";